import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

class ServicesApiService {
  async getTryChartClientId() {
    const response = await axiosClient.get<{ data: { client_id: string } }>(
      endpoints.SERVICES.TRY_CHART.GET_CLIENT_ID
    );
    return response.data.data.client_id;
  }
}

const servicesApiService = new ServicesApiService();
export default servicesApiService;
